import { resetRecipeGroups, setRecipeGroups } from 'js/actions';
import { completeTxBuilderRecipeGroups } from 'js/lib/RecipeBuilderUtils';
import TransformsUtils from 'js/lib/TransformsUtils';
import { getSamplesForDataSet } from 'js/reducers/samples';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export function useRecipeBuilderData(dataSet) {
  const dispatch = useDispatch();
  const state = useSelector((state: any) => state);
  const {
    recipeBuilder: { recipeGroups },
  } = state;
  const { transforms } = state.entities;
  const schemas = state.dataSetSchemas;
  const schema = schemas?.[dataSet.id] || null;
  // @ts-ignore
  const dataSetSamples = getSamplesForDataSet(state, { data: dataSet });

  useEffect(() => {
    if (!dataSet) {
      return;
    }

    const txSpec = dataSet.custom_config?.txSpec;
    let recipeGroups: any[];

    if (txSpec?.v === 2) {
      recipeGroups = txSpec.spec;
    } else {
      recipeGroups = TransformsUtils.getUpgradedTxSpec(dataSet, transforms);
    }

    dispatch(setRecipeGroups(completeTxBuilderRecipeGroups(recipeGroups, transforms)));

    return () => {
      dispatch(resetRecipeGroups());
    };
  }, []);

  return useMemo(() => {
    return {
      recipeGroups,
      schema: schema?.out,
      transforms,
      nestedSamples: dataSetSamples?.nestedSamples,
      samples: dataSetSamples?.samples,
      meta: schema?.outMetaData,
    };
  }, [schemas, state.samples, transforms, state.dataSetSchemas, state.recipeBuilder]);
}
